import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { fetchWishlists } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlists/actionCreators';
import { getWishlists } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlists/selectors';
import { WishlistsType } from 'b2b-common/core/account/api/wishlists';

export const useWishlistsEffect = (pageSize: number, startItem: number): RemoteRecord<WishlistsType> => {
  const dispatch = useDispatch();
  const wishlistsData = useSelector(getWishlists);

  useEffect(() => {
    dispatch(fetchWishlists(pageSize, startItem));
  }, [pageSize, startItem]);

  return wishlistsData;
};
